import { render } from "./wireframing.vue?vue&type=template&id=784605a0"
import script from "./wireframing.vue?vue&type=script&lang=js"
export * from "./wireframing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__